import { StanButton } from '@/components';
import { createIconElement } from '@/lib/utils/createIconElement';
import { useStanRouter } from '@/hooks/useStanRouter';
import CalendarIconSvg from '@/assets/icons/ic-calendar.svg';
import ListIconSvg from '@/assets/icons/ic-list.svg';
import SettingsIconSvg from '@/assets/icons/ic-settings.svg';

const CalendarIcon = createIconElement(CalendarIconSvg);
const ListIcon = createIconElement(ListIconSvg);
const SettingsIcon = createIconElement(SettingsIconSvg);

interface AppointmentsViewToggleProps {
    viewMode: 'calendar' | 'list';
    onViewModeChange: (mode: 'calendar' | 'list') => void;
}

export function AppointmentsViewToggle({ viewMode, onViewModeChange }: AppointmentsViewToggleProps) {
    const { push } = useStanRouter();

    const navigateToSettings = () => {
        push('/account_settings?tab=integrations');
    };

    return (
        <div className='flex items-center gap-2'>
            <StanButton
                name='calendar-view'
                onClick={() => onViewModeChange('calendar')}
                icon={CalendarIcon}
                color={viewMode === 'calendar' ? 'primary' : 'secondary'}
                variant={viewMode === 'calendar' ? undefined : 'ghost'}
                size='sm'
                className='flex-1 sm:flex-initial'
            >
                Calendar
            </StanButton>
            <StanButton
                name='list-view'
                onClick={() => onViewModeChange('list')}
                icon={ListIcon}
                color={viewMode === 'list' ? 'primary' : 'secondary'}
                variant={viewMode === 'list' ? undefined : 'ghost'}
                size='sm'
                className='flex-1 sm:flex-initial'
            >
                List
            </StanButton>
            <StanButton
                name='settings'
                onClick={navigateToSettings}
                icon={SettingsIcon}
                color='secondary'
                size='sm'
                className='!size-8 !min-w-0 !p-0'
            />
        </div>
    );
}
